import { useParams } from 'react-router-dom';
import queryClient from '../../../service/reactQuery/queryClient';
import { useFetchPlansOne, useFetchPlansPrice } from '../Service/query';
import {CreatePlanPriceRequest , DeletePlansRequest, EditPlansRequest, EditPriceRequest } from '../Service/request';
import { useMutation } from 'react-query';

// import { EditUserRequest, SignUpRequest } from "../Services/request";

const PlansState = () => {
    const { id } = useParams();
    const { data: plans, isLoading } = useFetchPlansOne(id);
    const { data: plansPrice } = useFetchPlansPrice(id);

    console.log(plansPrice);

    const EditPlansMutation = useMutation(({ body, close }) => EditPlansRequest(body), {
        onMutate: () => {},
        onError: (error) => {},
        onSuccess: (result, veriables, context) => {
            queryClient.refetchQueries('UsePlansAll');
            veriables.close();
        }
    });

    const EditPlanPriceMutation = useMutation(({ body, close, id }) => EditPriceRequest(body, id), {
        onMutate: () => {},
        onError: (error) => {},
        onSuccess: (result, veriables, context) => {
            queryClient.refetchQueries('UsePlansAll');
            veriables.close();
        }
    });


    const DeletePlansMutation = useMutation((id) => DeletePlansRequest(id), {
        onMutate: () => {},
        onError: (error) => {},
        onSuccess: (result, veriables, context) => {
            queryClient.refetchQueries('UsePlansAll');
        }
    });

    const CreatePlanMutation = useMutation(({ data, close }) => CreatePlanPriceRequest(data), {
        onMutate: () => {},
        onError: (error) => {},
        onSuccess: (result, variables, context) => {
            queryClient.refetchQueries('UsePlansPrice');
            variables.close();
        }
    });

    const CreatePlan = (body, close) => {
        CreatePlanMutation.mutate({ data: body, close: close });
    };

    const EditPlans = (body, close) => {
        EditPlansMutation.mutate({ body: body, close: close });
    };


    const EditPlanPrice = (body, id, close) => {
        EditPlanPriceMutation.mutate({ body: body, close: close, id: id });
    };
    
    const DeletePlans = (id) => {
        console.log(id);
        DeletePlansMutation.mutate(id);
    };

    return {
        plans,
        isLoading,
        EditPlans,
        CreatePlan,
        DeletePlans,
        plansPrice,
        EditPlanPrice
    };
};

export default PlansState;
